import {CollectionFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'

import {AppThunkAction} from '../../types/redux'

const apiClient = getAuthenticatedThemisClient()

const {actions, selectors, reducer} = CollectionFactory({
  actionNamePrefix: 'data/legalForms/collection',
  reducerPath: ['data', 'legalForms', 'collection'],
  fetchRequest: (state, {countryCode}) =>
    apiClient.StaticData.fetchLegalForms({countryCode: countryCode?.toUpperCase()})
      ?.then(res => res?.data()?.legalForms || [])
      .then(legalForms =>
        legalForms?.map((legalForm: string) => ({legalForm, internalId: legalForm}))
      ),

  entityPrimaryKeySelector: entity => entity?.internalId,
})

export const selectLegalFormsByCountryCode = (
  state: Record<string, any>,
  countryCode: string
): string[] =>
  selectors
    ?.selectByKeyWindow(state, {countryCode: countryCode?.toUpperCase()})
    ?.map(entity => entity?.legalForm)

export default reducer as Reducer

export const selectLegalFormsAreLoadingForCountry = (
  state: Record<string, any>,
  countryCode: string
): boolean => selectors?.selectIsKeyWindowLoading(state, {countryCode: countryCode?.toUpperCase()})

const aLegalFormsByCountryCode = (countryCode: string): AppThunkAction =>
  actions!.fetch({countryCode})

export const aEnsureLegalFormsByCountryCode =
  (countryCode: string): AppThunkAction<void> =>
  (dispatch, getState): void => {
    if (
      selectors?.selectIsKeyWindowLoading(getState(), {countryCode: countryCode?.toUpperCase()}) ||
      selectors?.selectFetchCountByKeyWindow(getState(), {
        countryCode: countryCode?.toUpperCase(),
      }) > 0
    ) {
      return
    }
    dispatch(aLegalFormsByCountryCode(countryCode))
  }
